import React, { Suspense, useLayoutEffect } from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import {
  ArchievedTicketManagement,
  BranchManagement,
  CurrencyManagement,
  CustomerDashboard,
  CustomerInvestment,
  DepartmentManagement,
  ExchangeRateManagement,
  FaqCategoryManagement,
  FaqManagement,
  GenderManagement,
  HandledRequests,
  Homepage,
  IdentificationType,
  InvestmentRateManagement,
  ManageMyCustomers,
  Managerole,
  ManageUser,
  MessageManagement,
  MyQueue,
  OpenTicketsManagement,
  PenalChargeManagement,
  PendingRequests,
  ProcessManagement,
  ProcessStage,
  ProductCategoryManagement,
  ProductManagement,
  ProductPropertyManagement,
  ReferralRewardsManagement,
  ReportManagementScreen,
  SourceManagement,
  TenorManagement,
  TicketCategoryManagement,
  WalletManagement,
  WithdrawalReasonManagement,
  WithholdingTaxManagement,
} from "../pages";
import { RedirectAs404 } from "../utils/Utils";
import { ProtectedRoute } from "./ProtectedRoute";
import DeleteRequests from "../pages/pre-built/requestMangement/DeleteRequests";
import CampaignDashboard from "../pages/pre-built/campaignManagement/campaignDashBoard";

const Pages = () => {
  const location = useLocation();
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  },[location.pathname]);

  return (
    <Suspense fallback={<div />}>
      <Switch>
        <Route exact path={`${process.env.PUBLIC_URL}/`} component={Homepage} />
        {/*Dashboards*/}
        <ProtectedRoute
          exact
          allowedRights={["VIEW_ADMIN_USER"]}
          path={`${process.env.PUBLIC_URL}/manage-users`}
          component={ManageUser}
        />
        <ProtectedRoute
          exact
          allowedRights={["VIEW_ROLE"]}
          path={`${process.env.PUBLIC_URL}/manage-roles`}
          component={Managerole}
        />
        <ProtectedRoute
          exact
          allowedRights={["VIEW_BRANCH"]}
          path={`${process.env.PUBLIC_URL}/manage-branch`}
          component={BranchManagement}
        />
        <ProtectedRoute
          exact
          allowedRights={["VIEW_DEPARTMENT"]}
          path={`${process.env.PUBLIC_URL}/department-management`}
          component={DepartmentManagement}
        />
        <ProtectedRoute
          exact
          allowedRights={["VIEW_PRODUCT_CATEGORY"]}
          path={`${process.env.PUBLIC_URL}/product-category`}
          component={ProductCategoryManagement}
        />
        <ProtectedRoute
          exact
          allowedRights={["VIEW_PRODUCT"]}
          path={`${process.env.PUBLIC_URL}/products`}
          component={ProductManagement}
        />
        <ProtectedRoute
          exact
          allowedRights={["VIEW_TENOR"]}
          path={`${process.env.PUBLIC_URL}/tenor-management`}
          component={TenorManagement}
        />
        <ProtectedRoute
          exact
          allowedRights={["VIEW_WITHDRAWAL_REASON"]}
          path={`${process.env.PUBLIC_URL}/withdrawal-reason`}
          component={WithdrawalReasonManagement}
        />
        <ProtectedRoute
          exact
          allowedRights={["VIEW_CURRENCY"]}
          path={`${process.env.PUBLIC_URL}/currency-management`}
          component={CurrencyManagement}
        />
        <ProtectedRoute
          exact
          allowedRights={["VIEW_INVESTMENT_RATE"]}
          path={`${process.env.PUBLIC_URL}/investment-rate`}
          component={InvestmentRateManagement}
        />
        <ProtectedRoute
          exact
          allowedRights={["VIEW_WITHHOLDING_TAX_RATE"]}
          path={`${process.env.PUBLIC_URL}/withholding-tax`}
          component={WithholdingTaxManagement}
        />
        <ProtectedRoute
          exact
          allowedRights={["VIEW_PENAL_CHARGE"]}
          path={`${process.env.PUBLIC_URL}/penal-charge`}
          component={PenalChargeManagement}
        />
        <ProtectedRoute
          exact
          allowedRights={["VIEW_EXCHANGE_RATE"]}
          path={`${process.env.PUBLIC_URL}/exchange-rate`}
          component={ExchangeRateManagement}
        />
        <ProtectedRoute
          exact
          allowedRights={["VIEW_PRODUCT_PROPERTY"]}
          path={`${process.env.PUBLIC_URL}/project-property`}
          component={ProductPropertyManagement}
        />
        <ProtectedRoute
          exact
          allowedRights={["VIEW_WALLET_MANAGEMENT"]}
          path={`${process.env.PUBLIC_URL}/wallet-management`}
          component={WalletManagement}
        />

        <ProtectedRoute
          allowedRights={["VIEW_PROCESS_FLOW"]}
          exact
          path={`${process.env.PUBLIC_URL}/process-management`}
          component={ProcessManagement}
        />
        <ProtectedRoute
          allowedRights={["VIEW_PROCESS_FLOW"]}
          exact
          path={`${process.env.PUBLIC_URL}/manage-process-stage`}
          component={ProcessStage}
        />

        <ProtectedRoute
          allowedRights={["VIEW_CUSTOMER", "CREATE_INVESTMENT"]}
          exact
          path={`${process.env.PUBLIC_URL}/customer-databoard`}
          component={CustomerDashboard}
        />
        <ProtectedRoute
          allowedRights={["WITHDRAW_INVESTMENT", "TOPUP_INVESTMENT", "TRANSFER_INVESTMENT"]}
          exact
          path={`${process.env.PUBLIC_URL}/customer-investments`}
          component={CustomerInvestment}
        />
        <ProtectedRoute
          allowedRights={["VIEW_GENDER"]}
          exact
          path={`${process.env.PUBLIC_URL}/manage-gender`}
          component={GenderManagement}
        />
        <ProtectedRoute
          allowedRights={["VIEW_IDENTIFICATION_TYPE"]}
          exact
          path={`${process.env.PUBLIC_URL}/identifation-type`}
          component={IdentificationType}
        />
        <ProtectedRoute
          allowedRights={["VIEW_SOURCE"]}
          exact
          path={`${process.env.PUBLIC_URL}/source-management`}
          component={SourceManagement}
        />

        <ProtectedRoute
          allowedRights={["ADMIN"]}
          exact
          path={`${process.env.PUBLIC_URL}/open-tickets`}
          component={OpenTicketsManagement}
        />
        <ProtectedRoute
          allowedRights={["ADMIN"]}
          exact
          path={`${process.env.PUBLIC_URL}/archived-tickets`}
          component={ArchievedTicketManagement}
        />
        <ProtectedRoute
          allowedRights={["VIEW_TICKET_CATEGORY"]}
          exact
          path={`${process.env.PUBLIC_URL}/manage-ticket-category`}
          component={TicketCategoryManagement}
        />
        <ProtectedRoute
          allowedRights={["VIEW_FAQ_CATEGORY"]}
          exact
          path={`${process.env.PUBLIC_URL}/manage-faq-category`}
          component={FaqCategoryManagement}
        />
        <ProtectedRoute
          allowedRights={["VIEW_FAQ"]}
          exact
          path={`${process.env.PUBLIC_URL}/manage-faq`}
          component={FaqManagement}
        />
        <ProtectedRoute
          allowedRights={["VIEW_MESSAGE"]}
          exact
          path={`${process.env.PUBLIC_URL}/manage-messages`}
          component={MessageManagement}
        />
        <ProtectedRoute
          allowedRights={["ADMIN"]}
          exact
          path={`${process.env.PUBLIC_URL}/manage-my-customers`}
          component={ManageMyCustomers}
        />
        <ProtectedRoute
          allowedRights={["ADMIN"]}
          exact
          path={`${process.env.PUBLIC_URL}/pending-requests`}
          component={PendingRequests}
        />
        <ProtectedRoute
          allowedRights={["ADMIN"]}
          exact
          path={`${process.env.PUBLIC_URL}/delete-requests`}
          component={DeleteRequests}
        />
        <ProtectedRoute
          allowedRights={["ADMIN"]}
          exact
          path={`${process.env.PUBLIC_URL}/campaign-management`}
          component={CampaignDashboard}
        />
        <ProtectedRoute
          allowedRights={["ADMIN"]}
          exact
          path={`${process.env.PUBLIC_URL}/my-queue`}
          component={MyQueue}
        />
        <ProtectedRoute
          allowedRights={["ADMIN"]}
          exact
          path={`${process.env.PUBLIC_URL}/handled-requests`}
          component={HandledRequests}
        />
        <ProtectedRoute
          allowedRights={["VIEW_REPORT"]}
          exact
          path={`${process.env.PUBLIC_URL}/report`}
          component={ReportManagementScreen}
        />
        <ProtectedRoute
          allowedRights={["ADMIN"]}
          exact
          path={`${process.env.PUBLIC_URL}/referral-rewards`}
          component={ReferralRewardsManagement}
        />
        <Route component={RedirectAs404} />
      </Switch>
    </Suspense>
  );
};
export default Pages;
